import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from "../../providers/order/order";
import { PostCommentProvider } from "../../providers/post-comment/post-comment";
import { PostComment } from "../../models/post-comment.model";

import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';
import { User } from '../../models/user.model';

@IonicPage()
@Component({
  selector: 'page-post-comments',
  templateUrl: 'post-comments.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class PostCommentsPage {
  
  public postComments: PostComment[];
  public showPostComments: PostComment[];

  private postId: number; 
  private commentId: number; 

  public loading: boolean;

  public user: User;

  public addEdit: boolean = false;
  public isEdit: boolean = false;

  public title: string;
  public comment: string;

  

  constructor(public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, private postCommentProvider: PostCommentProvider, public authProvider: AuthProvider) {
    
    this.postId = navParams.get('postId');
  }

  getPostComments() {
    this.loading = true;
    this.getProfile().then(() => { 
      this.postCommentProvider.comments(this.postId)
      .subscribe(
        postComments =>{
          this.postComments = postComments
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.postComments = undefined;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }).catch(error => {
      if (error.status == 401) {
        this.disconnected();
      }
      console.log(error)
    });
  }
  
  private getProfile() {
    return new Promise((resolve, reject) => {
      this.authProvider.profile()
        .subscribe(
          user => {
            this.user = new User(user);
            resolve();
          },
          error => {
            reject(error);
          }
        );
    });
  }

  displayAdd() {
    this.addEdit = true;
  }

  edit(postComment) {
    this.isEdit = true;
    this.title = postComment.title;
    this.comment = postComment.content;
    this.commentId = postComment.id;
    this.addEdit = true;
  }

  remove(postComment) {
    this.loading = true;
    this.postCommentProvider.removeComment(postComment.id)
      .subscribe(
        postComments =>{
          this.postComments = postComments
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          console.log(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  send() {
    this.loading = true;

    if(!this.title || !this.comment) {
      this.loading = false;
    } else {
      let send;
      if (this.isEdit) {
        send = this.postCommentProvider.editComment({
          commentId : this.commentId,
          title: this.title,
          content: this.comment
        });
      } else {
        send = this.postCommentProvider.postComment({
          postId : this.postId,
          title: this.title,
          content: this.comment
        });
      }

      send.subscribe(
        res => {
          this.postComments = res;
          this.addEdit = false;
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          console.log(error);
          this.loading = false;
        },
        () => {
          if (this.edit) {
            this.isEdit = false;
            this.title = "";
            this.comment = "";
            this.commentId = 0;
          }

          this.loading = false;
        }
      );
    }
  }

  cancel() {
    this.addEdit = false;
  }

  reloadPostComments(refresher) {
    this.getPostComments();
    refresher.complete();
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getPostComments();
  }

}



// WEBPACK FOOTER //
// ./src/pages/post-comments/post-comments.ts